module.exports = __webpack_public_path__ + "img/1580547992.674a08e1.jpg";